class ProductFormBis extends HTMLElement {
  constructor() {
    super();

    this.product = this.querySelector('[name="bis[product]"]') || false;
    this.variant = this.querySelector('[name="id"]') || false;
    this.email = this.querySelector('[name="bis[email]"]') || false;
    this.button = document.querySelector('.js-bis-submit') || false;
    this.modal = this.closest('hh-modal');
    this.modalId = this.modal.dataset.modalId || '';
    this.errorMessageWrapper = this.querySelector('.js-error-wrapper') || false;
    this.errorMessageEl = this.errorMessageWrapper.querySelector('.js-error-message') || false;

    this._attachEventHandlers()
  }

  _attachEventHandlers() {
    this.modal.addEventListener('handle-action', (e) => {
      if (e.detail === 'submit') this.submitNotification()
    })

    this.modal.addEventListener('close', () => {
      this.clearForm()
    })

    this.email.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') this.submitNotification()
    });
  }

  submitNotification() {
    const productId = this.product?.value
    const variantId = this.variant?.value
    const email = this.email?.value

    if (!email) this.handleErrorMessage('Email address is required.')

    if (email && variantId && productId) {
      BIS.create(email, variantId, productId)
      .then((response) => {
        if (response.status === 'Error') {
          this.handleErrorMessage(Object.values(response.errors)[0][0]);
        }
        if (response.status === 'OK') {
          this.handleSuccessfulNotification()
        }
        return response;
      })
    }
  }

  clearForm() {
    this.email.value = '';
    this.errorMessageWrapper.toggleAttribute('hidden', true);
    this.errorMessageEl.textContent = '';
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessageEl.textContent = errorMessage;
    }
  }

  handleSuccessfulNotification() {
    document.dispatchEvent(new CustomEvent('close-modal', {
      detail: {
        modal_name: `js-bis-form-${this.modalId}`
      }
    }))
    document.dispatchEvent(new CustomEvent('open-modal', {
      detail: {
        modal_name: `js-bis-form-success-${this.modalId}`
      }
    }))
  }
}

customElements.define('product-form-bis', ProductFormBis);
